import Colorway, { Colorways } from '@uds/colorway';
import { jsx } from 'react/jsx-runtime';

function GenericAction(_ref) {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/jsx(Colorway, {
    component: "span",
    colorway: Colorways.LIGHT,
    className: className,
    children: children
  });
}

export { GenericAction as default };
